import React from 'react'
import { DataTable, TextInput, Button } from '@paypalcorp/pp-react'
import Fuse from 'fuse.js'

// This object is used in the cardSupportedCurrenciesACDC_Focus_Columns array of the SearchableTableACDCNotCollapsed object to format content defined in the cardSupportedCurrenciesACDC_Focus_Rows array.
// CountryCell takes 2 strings and returns the country as a string, and returns the countryCode in code format, wrapped in parenthesis, as HTML content.
// The expected input for country is the name of a country.
// The expected input for countryCode is a 2-character country code for the value passed in the country parameter.
// Note: CountryCell doesn't sanitize the input, so the values could be anything.

const CountryCell = (country, countryCode) => {
  return (
    <div>
      {country.value} (<code>{country.countryCode}</code>)
    </div>
  )
}

export default CountryCell
